import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { XCircle, Home, ShoppingCart, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancelled = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Payment Cancelled",
      subtitle: "Your payment was not completed",
      description: "Don't worry! Your cart items are still saved. You can try again whenever you're ready, or contact us if you need assistance.",
      backHome: "Back to Home",
      tryAgain: "Return to Cart",
      needHelp: "Need Help?",
      contactUs: "Contact us on WhatsApp"
    },
    ar: {
      title: "تم إلغاء الدفع",
      subtitle: "لم يتم إكمال الدفع",
      description: "لا تقلق! العناصر في سلتك محفوظة. يمكنك المحاولة مرة أخرى عندما تكون جاهزاً، أو تواصل معنا إذا كنت بحاجة للمساعدة.",
      backHome: "العودة للرئيسية",
      tryAgain: "العودة للسلة",
      needHelp: "تحتاج مساعدة؟",
      contactUs: "تواصل معنا على واتساب"
    }
  };

  const t = content[language];

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 flex items-center justify-center p-4">
        <div className="max-w-lg w-full">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center">
            {/* Cancelled Icon */}
            <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6" role="img" aria-label="Cancelled">
              <XCircle className="w-16 h-16 text-orange-500" />
            </div>

            {/* Title */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              {t.title}
            </h1>
            <p className="text-xl text-orange-600 font-semibold mb-6">
              {t.subtitle}
            </p>

            {/* Description */}
            <p className="text-gray-600 mb-8 leading-relaxed">
              {t.description}
            </p>

            {/* Action Buttons */}
            <div className="space-y-4">
              <Link to="/" className="block">
                <Button className="w-full bg-teal-600 hover:bg-teal-700 text-white py-6 text-lg rounded-xl">
                  <Home className={`w-5 h-5 ${language === 'ar' ? 'ml-2' : 'mr-2'}`} />
                  {t.backHome}
                </Button>
              </Link>
              <Link to="/" className="block">
                <Button variant="outline" className="w-full py-6 text-lg rounded-xl">
                  <ShoppingCart className={`w-5 h-5 ${language === 'ar' ? 'ml-2' : 'mr-2'}`} />
                  {t.tryAgain}
                </Button>
              </Link>
            </div>

            {/* Help Section */}
            <div className="mt-8 pt-6 border-t border-gray-100">
              <p className="text-gray-500 text-sm mb-4">{t.needHelp}</p>
              <a
                href="https://wa.me/16478745620"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-[#25D366] hover:text-[#20BA5A] font-semibold"
                aria-label={language === 'en' ? 'Contact us on WhatsApp' : 'تواصل معنا على واتساب'}
              >
                <MessageCircle className={`w-5 h-5 ${language === 'ar' ? 'ml-2' : 'mr-2'}`} />
                {t.contactUs}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentCancelled;
